var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAlexaForBusiness32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Alexa-For-Business_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0816",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5252",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Alexa-For-Business_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/32/Business-Applications",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15,21.0024628 L20,21.0024628 L20,19.9965313 L15,19.9965313 L15,21.0024628 Z M15,18.9905997 L26,18.9905997 L26,17.9846682 L15,17.9846682 L15,18.9905997 Z M15,16.9787367 L24,16.9787367 L24,15.9728052 L15,15.9728052 L15,16.9787367 Z M20,10.0237261 C15.589,10.0237261 12,13.6340144 12,18.0711783 C12,21.3052482 13.885,24.2013251 16.802,25.4496861 L16.998,25.5110479 C17.224,25.5844809 17.487,25.670991 17.727,25.7585071 L19.699,26.4827778 C19.896,26.5552048 20.027,26.743314 20.027,26.9545596 L20.027,29.505602 C24.825,27.2855111 28,22.7739082 28,18.0711783 C28,13.6340144 24.411,10.0237261 20,10.0237261 L20,10.0237261 Z M19.527,30.7720698 C19.429,30.7720698 19.331,30.7428978 19.247,30.6855597 C19.109,30.592008 19.027,30.4360887 19.027,30.269104 L19.027,27.3066357 L17.384,26.7030768 C17.157,26.6195844 16.905,26.538104 16.69,26.4686947 L16.452,26.3902321 C13.124,24.9688508 11,21.7096327 11,18.0711783 C11,13.0787402 15.037,9.01779458 20,9.01779458 C24.963,9.01779458 29,13.0787402 29,18.0711783 C29,23.4016095 25.269,28.4906171 19.714,30.7358563 C19.653,30.7599986 19.591,30.7720698 19.527,30.7720698 L19.527,30.7720698 Z M20,7.00593153 C13.935,7.00593153 9,11.9691977 9,18.0711783 C9,22.5194075 11.636,26.5199972 15.715,28.2612647 C15.782,28.2904367 15.918,28.3326858 16.08,28.3849943 C16.271,28.4463561 16.496,28.5197891 16.699,28.5932221 C16.896,28.6666551 17.027,28.8547643 17.027,29.0660099 L17.027,33.7777932 L18.169,33.3583197 C25.623,31.4208956 31,24.9980228 31,18.0711783 C31,11.9691977 26.065,7.00593153 20,7.00593153 L20,7.00593153 Z M16.527,35 C16.426,35 16.326,34.9688161 16.241,34.9094662 C16.107,34.8149086 16.027,34.6610011 16.027,34.4970342 L16.027,29.4251275 C15.94,29.3959555 15.854,29.3677894 15.774,29.3426411 C15.575,29.2782615 15.408,29.2229352 15.324,29.1877276 C10.875,27.287523 8,22.9247979 8,18.0711783 C8,11.4149294 13.383,6 20,6 C26.617,6 32,11.4149294 32,18.0711783 C32,25.4496861 26.308,32.281973 18.466,34.3179784 L16.699,34.9698221 C16.644,34.9899407 16.585,35 16.527,35 L16.527,35 Z",
    id: "Alexa-For-Business_Icon_32_Squid",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAlexaForBusiness32);
export default __webpack_public_path__ + "static/media/Arch_Alexa-For-Business_32.5f776d3fcc3476aa05fb54d7e0bc2218.svg";
export { ForwardRef as ReactComponent };